import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Puma_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalChivas = () => {
  return (
    <>
      <ModalVideo
        id="spot-chivas"
        dataText={Puma_Title}
        videoSrc="https://player.vimeo.com/video/381595097?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_CHIVAS"
      />
    </>
  );
};

export default ModalChivas;
